import { Box } from "@chakra-ui/react"
import { Footer } from "@/-components/Footer"
import { ContactComponent } from "@/-sections/Contact"

const Contact = () => {
  return (
      <Box w="full" bg="white">
        <ContactComponent />
        <Footer />
      </Box>
  )
}

export default Contact